import { dataSourceTypes } from "@/enums/common";

const dataSourceOperators = Object.freeze({
    [dataSourceTypes.googleAnalytics]: [
        { title: "EQUAL TO", id: "EQUAL TO" },
        { title: "NOT EQUAL TO", id: "NOT EQUAL TO" },
        { title: "CONTAINING", id: "CONTAINING" },
        { title: "NOT CONTAINING", id: "NOT CONTAINING" },
        { title: "MATCHING REGEX", id: "MATCHING REGEX", },
        { title: "NOT MATCHING REGEX", id: "NOT MATCHING REGEX" },
    ],
    [dataSourceTypes.googleAds]: [
        { title: "EQUAL TO", id: "EQUAL TO" },
        { title: "NOT EQUAL TO", id: "NOT EQUAL TO" },
        { title: "CONTAINING", id: "CONTAINING" },
        { title: "NOT CONTAINING", id: "NOT CONTAINING" },
        { title: "MATCHING REGEX", id: "MATCHING REGEX", },
        { title: "NOT MATCHING REGEX", id: "NOT MATCHING REGEX" },
    ],
    [dataSourceTypes.googleSearchConsole]: [
        { title: "EQUAL TO", id: "EQUAL TO" },
        { title: "NOT EQUAL TO", id: "NOT EQUAL TO" },
        { title: "CONTAINING", id: "CONTAINING" },
        { title: "NOT CONTAINING", id: "NOT CONTAINING" },
        { title: "MATCHING REGEX", id: "MATCHING REGEX" },
        { title: "NOT MATCHING REGEX", id: "NOT MATCHING REGEX" },
    ],
    [dataSourceTypes.facebook]: [
        { title: "EQUAL TO", id: "EQUAL TO" },
        { title: "NOT EQUAL TO", id: "NOT EQUAL TO" },
        { title: "CONTAINING", id: "CONTAINING" },
        { title: "NOT CONTAINING", id: "NOT CONTAINING" },
    ]
});

const dataSourceFields = Object.freeze({
    [dataSourceTypes.googleAnalytics]: [
        { title: "Landing Page", id: "ga:landingPagePath" },
        { title: "Source / Medium", id: "ga:sourceMedium" },
        { title: "Campaign", id: "ga:campaign" },
        { title: "Search Query", id: "ga:adMatchedQuery" },
        { title: "Keyword", id: "ga:keyword" },
        { title: "Page", id: "ga:pagePath" },
        { title: "Host Name", id: "ga:hostName" },
    ],
    [dataSourceTypes.googleSearchConsole]: [
        { id: "query", title: "Query" },
        { id: "page", title: "Page" },
    ],
    [dataSourceTypes.googleAds]: [
        { id: "campaign.name", title: "Campaign Name" },
        { id: "campaign.advertising_channel_type", title: "Campaign Type" },
        { id: "expanded_landing_page_view.expanded_final_url", title: "Final Url" },
        { id: "ad_group.name", title: "Ad Group Name" },
        { id: "ad_group_criterion.keyword.text", title: "Keyword" },
    ],
    [dataSourceTypes.facebook]: [
        { id: "campaign.name", title: "Campaign Name" },
        { id: "adset.name", title: "Ad Set Name" },
        { id: "ad.name", title: "Ad Name" },
        { id: "link_url_asset", title: "Link URL Asset" },
    ],
    "exceptionPackages": {
        [dataSourceTypes.googleAnalytics]: {
            "kpi-monthly-google-ads-budget":
                [
                    { title: "Source / Medium", id: "ga:sourceMedium" },
                    { title: "Campaign", id: "ga:campaign" },
                    { title: "Search Query", id: "ga:adMatchedQuery" },
                    { title: "Keyword", id: "ga:keyword" },
                    { title: "Page", id: "ga:pagePath" },
                    { title: "Host Name", id: "ga:hostName" },
                ],
            "kpi-monthly-target-google-ads-roas":
                [
                    { title: "Source / Medium", id: "ga:sourceMedium" },
                    { title: "Campaign", id: "ga:campaign" },
                    { title: "Page", id: "ga:pagePath" },
                    { title: "Host Name", id: "ga:hostName" },
                ],
            "kpi-monthly-target-conversion-rate": [
                { title: "Landing Page", id: "ga:landingPagePath" },
                { title: "Source / Medium", id: "ga:sourceMedium" },
                { title: "Campaign", id: "ga:campaign" },
                { title: "Search Query", id: "ga:adMatchedQuery" },
                { title: "Keyword", id: "ga:keyword" },
                { title: "City", id: "ga:city" },
                { title: "Country", id: "ga:country" },
                { title: "Page", id: "ga:pagePath" },
                { title: "Host Name", id: "ga:hostName" },
            ]
        }
    }
});


const exceptionKPIPackages = [
    "kpi-monthly-google-ads-budget",
    "kpi-monthly-target-google-ads-roas",
    "kpi-monthly-target-conversion-rate"
]

const kpiFilterNamesBySourceTypes = {
    [dataSourceTypes.googleAnalytics]: "user_generic_ga_filters",
    [dataSourceTypes.googleSearchConsole]: "user_generic_searchconsole_filters",
    [dataSourceTypes.googleAds]: "user_generic_adwords_filters",
    [dataSourceTypes.facebook]: "user_generic_facebook_filters"
}

export {
    dataSourceFields,
    dataSourceOperators,
    kpiFilterNamesBySourceTypes,
    exceptionKPIPackages
}



// WEBPACK FOOTER //
// ./src/enums/kpis/index.js